"use strict";

import { c as _c } from "react/compiler-runtime";
import { getFeatureName, setFeatureName } from '@autoguru/feature-identification';
import { createContext, useContext } from 'react';
import { createLoggingAgent } from '../new-relic';
import { jsx as _jsx } from "react/jsx-runtime";
export const LoggingAgentContext = /*#__PURE__*/createContext(null);
export const LoggingAgentProvider = t0 => {
  const $ = _c(8);
  const {
    children,
    options,
    agentIdentifier: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? getFeatureName() : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const agentIdentifier = t2;
  setFeatureName({
    mfeAppName: __GDU_APP_NAME__
  });
  let t3;
  if ($[2] !== agentIdentifier || $[3] !== options) {
    t3 = createLoggingAgent({
      options,
      agentIdentifier
    });
    $[2] = agentIdentifier;
    $[3] = options;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const agent = t3;
  let t4;
  if ($[5] !== agent || $[6] !== children) {
    t4 = /*#__PURE__*/_jsx(LoggingAgentContext.Provider, {
      value: agent,
      children: children
    });
    $[5] = agent;
    $[6] = children;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
const isBrowser = typeof window !== 'undefined';
export const useLoggingAgent = () => {
  return isBrowser ? useContext(LoggingAgentContext) : null;
};